import { validateEmailWithResponse } from "../validateEmail";
import { validatePassword } from "../validatePassword";

export const useFormValidation = (formGroup, setFormGroup) => {
  const requiredFieldValidation = (name, value, $formGroup) => {
    if ($formGroup[name]?.validators.isRequired && value === "") {
      return {
        ...$formGroup,
        [name]: {
          ...$formGroup[name],
          isValid: false,
          isDirty: true,
          error: "This field is required",
        },
      };
    }

    return $formGroup;
  };

  const emailValidation = (name, value, $formGroup) => {
    if ($formGroup[name].validators.isValidEmail) {
      const errorMessage = validateEmailWithResponse(value).errors;

      return {
        ...$formGroup,
        [name]: {
          ...$formGroup[name],
          isValid: errorMessage.length === 0,
          isDirty: true,
          error: errorMessage.length > 0 ? errorMessage : "",
        },
      };
    }

    return $formGroup;
  };

  const passwordValidation = (name, value, $formGroup) => {
    if ($formGroup[name].validators.isPassword) {
      const errorMessage = validatePassword(value, $formGroup);

      return {
        ...$formGroup,
        [name]: {
          ...$formGroup[name],
          isValid: errorMessage.isValid,
          isDirty: true,
          error: errorMessage.errors.length ? errorMessage.errors : "",
        },
      };
    }

    return $formGroup;
  };

  const resetValidation = (event) => {
    const { name, value } = event.target;
    let $formGroup = formGroup;

    $formGroup = requiredFieldValidation(name, value, $formGroup);
    $formGroup = emailValidation(name, value, $formGroup);
    $formGroup = passwordValidation(name, value, $formGroup);

    setFormGroup($formGroup);
  };

  const validateForm = (event) => {
    const { name, value } = event.target;

    let $formGroup = {
      ...formGroup,
      [name]: {
        ...formGroup[name],
        isValid: true,
        isDirty: true,
        error: "",
        value,
      },
    };

    if (!$formGroup[name].validators) {
      setFormGroup($formGroup);
      return;
    }

    $formGroup = requiredFieldValidation(name, value, $formGroup);
    $formGroup = emailValidation(name, value, $formGroup);
    $formGroup = passwordValidation(name, value, $formGroup);

    setFormGroup($formGroup);
  };

  return {
    validateForm,
    resetValidation,
  };
};
